<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader title="Manage Attributes " />
        <div class="loader">
          <Wave
            v-if="loading || updating || deleting"
            width="50px"
            color="#d9534f"
          />
        </div>
        <div>
          <md-button class="md-primary" :to="{ name: 'Create Attribute' }">
            Add New Attribute
          </md-button>
        </div>
      </div>
      <md-table
        v-model="attributes.mdData"
        md-card
        md-sort="title"
        md-sort-order="asc"
      >
        <md-table-toolbar class="mb-4">
          <div class="md-toolbar-section-start">
            <!-- <md-button class="md-primary button-icon" disabled>
              Download Excel
              <img src="@/assets/svg/excel.svg" />
            </md-button> -->
          </div>
          <div class="toolbar-filter-wrapper">
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Search by name..." v-model="search" />
            </md-field>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="S/N">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="Title">{{ item.title }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <md-menu md-size="medium">
              <div v-if="hasPermission">
                <md-button :disabled="updating" md-menu-trigger class="bggreen"
                  >Menu</md-button
                >
              </div>
              <md-menu-content>
                <router-link
                  tag="md-menu-item"
                  :to="{ name: 'Edit Attribute', params: { id: item.id } }"
                >
                  Edit
                </router-link>
              </md-menu-content>
            </md-menu>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <span v-if="loading" class="b-loading">Loading...</span>
      <pagination
        v-model="attributes.mdPage"
        :records="attributes.mdCount"
        :per-page="attributes.mdPerPage"
        @paginate="updatePagination"
      />
    </md-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("product");
export default {
  name: "User",
  data() {
    return {
      updating: false,
      deleting: false,
      search: "",
      time: null
    };
  },
  watch: {
    search(val) {
      this.waitForIt(val);
    }
  },

  methods: {
    ...mapActions(["getAttributes"]),
    async updatePagination(page) {
      let data = { page };
      if (this.search) data.keyword = this.search;
      await this.getAttributes(data);
    },
    async submitSearch() {
      await this.getAttributes({ keyword: this.search });
    },
    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    }
  },
  created() {},
  mounted() {
    this.getAttributes();
  },
  computed: {
    ...mapGetters(["attributes", "loading"]),
    hasPermission() {
      return this.$store.getters["auth/has_module_permission"]("crud");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-table-cell {
  width: 0% !important;
  padding: 0rem 0.8rem;
}

.md-table + .md-table {
  margin-top: 16px;

  thead {
    height: 50px !important;
  }
}
</style>
